import { DatasetDataLagLeadRequest } from "api/model/requests";
import { DweenTimeUnitEnum } from "utils/time-utils";
import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { ChronoUnit, LocalTime, ZonedDateTime, ZoneId } from "@js-joda/core";
import { ICombinedData, IDataConfigLocal, IDataSetConfig } from "./common/api/interfaces/interfaces";

export const getExtractedDataValue = (data: any, decimalPlace?: number): any => {
  if (data.length > 0) {
    const value = data[data.length - 1]?.value;
    if (typeof value === "number") {
      return value.toFixed(decimalPlace != null ? decimalPlace : 2);
    }
    return value;
  }
  return null;
};

export const formatValueWithGivenDecimalPlace = (
  dataNumber: number,
  value: String,
  decimalPlace?: number
) => {
  return `${dataNumber.toFixed(decimalPlace != null ? decimalPlace : 2)} ${value}`;
};

export const fmtLocalTime = (time: string): string => {
  const lTime = LocalTime.parse(time);
  return lTime.toString();
};

export const getDataConfigLocalFullyFilledConfig = (configLocal: IDataConfigLocal) => {
  const configToSend: DatasetDataLagLeadRequest = {};

  if (configLocal.alignStartTo) {
    configToSend.startAlignUnit = configLocal.alignStartTo as DweenTimeUnitEnum;
  } else {
    configToSend.startAlignUnit = "HOURS" as DweenTimeUnitEnum;
  }

  if (configLocal.timeOffset) {
    configToSend.lag = -1 * configLocal.timeOffset;
    configToSend.lead = configLocal.timeOffset;
  } else {
    configToSend.lag = 0;
    configToSend.lead = 0;
  }

  if (configLocal.timeOffsetUnits) {
    configToSend.lagUnit = configLocal.timeOffsetUnits as DweenTimeUnitEnum;
    configToSend.leadUnit = configLocal.timeOffsetUnits as DweenTimeUnitEnum;
  } else {
    configToSend.lagUnit = "HOURS" as DweenTimeUnitEnum;
    configToSend.leadUnit = "HOURS" as DweenTimeUnitEnum;
  }

  return configToSend;
};

export const getDateFromGivenConfig = (config: IDataConfigLocal, zoneId: ZoneId) => {
  let firstTimeDate = ZonedDateTime.now(zoneId);
  const lag = config.timeOffset ? config.timeOffset : 0;

  if (config.alignStartTo) {
    if (config.alignStartTo === "DAYS") {
      firstTimeDate = firstTimeDate.truncatedTo(ChronoUnit.DAYS);
    } else if (config.alignStartTo === "HOURS" || !config.alignStartTo) {
      firstTimeDate = firstTimeDate.truncatedTo(ChronoUnit.HOURS);
    }
  }

  // TODO: itariu slepiasi typo cia (using lag instead of timeOffset ?)
  if (config.timeOffsetUnits) {
    if (config.timeOffsetUnits === "DAYS") {
      firstTimeDate = firstTimeDate.plus(lag, ChronoUnit.DAYS);
    } else if (config.timeOffsetUnits === "MINUTES") {
      firstTimeDate = firstTimeDate.plus(lag, ChronoUnit.MINUTES);
    } else {
      firstTimeDate = firstTimeDate.plus(lag, ChronoUnit.HOURS);
    }
  } else {
    firstTimeDate = firstTimeDate.plus(lag, ChronoUnit.HOURS);
  }

  return firstTimeDate.toDate();
};

export const numberArrayToBooleanConverter = (value?: Array<InstantDoubleValue>) => {
  if (!value) {
    return undefined;
  }
  if (value.length === 0) {
    return undefined;
  }

  return value[0].value !== 0;
};

export const remakeArrayIntoOtherInterface = (data: any, datasets: Array<IDataSetConfig>) => {
  const gotDataArr: DatasetDataInfoResponse[] = data;
  const arr: ICombinedData[] = [];

  for (let i = 0; i < gotDataArr.length; i++) {
    let decimalPlaces = 2;
    if (datasets[i] && datasets[i].decimalPlaces != null) {
      decimalPlaces = datasets[i].decimalPlaces as number;
    } else if (gotDataArr[i] && gotDataArr[i].decimalPlaces != null) {
      decimalPlaces = gotDataArr[i].decimalPlaces as number;
    }

    const a: ICombinedData = {
      identifier: gotDataArr[i].identifier,
      title: gotDataArr[i].title,
      data: gotDataArr[i].data,
      unit: gotDataArr[i].unit,
      overriddenTitle: datasets[i].overriddenTitle || "",
      decimalPlaces,
      description: datasets[i].description || "",
      type: datasets[i].type?.toUpperCase() || "NUMBER",
      enum: datasets[i].enum,
    };

    if (datasets[i].toggle) {
      a.type = "BOOLEAN";
    }

    arr.push(a);
  }

  return arr;
};
